<ng-content />

<ng-template #overflowItemTemplate let-item>
	<button mat-menu-item (click)="item.run()">
		@if (item.icon) {
			<mat-icon>{{item.icon}}</mat-icon>
		}
		<span>{{item.label}}</span>
	</button>
</ng-template>

@if (showOverflowMenu()) {
	<button
		class="overflow-trigger"
		mat-icon-button
		[matMenuTriggerFor]="overflowMenu"
		matTooltip="More options"
		aria-label="Show more actions"
	>
		<mat-icon>more_vert</mat-icon>
	</button>

	<mat-menu #overflowMenu="matMenu" class="custom-mat-panel">

		<!-- Top-level overflow menu items from direct button hosts (action/pinned roles). -->
		@for (item of overflowFlatItems(); track item.label) {
			<ng-container *ngTemplateOutlet="overflowItemTemplate; context: { $implicit: item }" />
		}

		<!-- Single-group overflow menu items from wrapper hosts (menu role with OVERFLOW_MENU_SOURCE). -->
		@if (overflowWrapperGroups().length === 1 && overflowFlatItems().length === 0) {
			@for (item of overflowWrapperGroups()[0].items; track item.label) {
				<ng-container *ngTemplateOutlet="overflowItemTemplate; context: { $implicit: item }" />
			}
		}
		@else {
			<!-- Multi-group overflow submenus from wrapper hosts (menu role with OVERFLOW_MENU_SOURCE). -->
			@for (group of overflowWrapperGroups(); track group.label) {
				<button mat-menu-item [matMenuTriggerFor]="groupMenu">
					@if (group.icon) {
						<mat-icon>{{group.icon}}</mat-icon>
					}
					<span>{{group.label}}</span>
				</button>

				<mat-menu #groupMenu="matMenu" class="custom-mat-panel">
					@for (item of group.items; track item.label) {
						<ng-container *ngTemplateOutlet="overflowItemTemplate; context: { $implicit: item }" />
					}
				</mat-menu>
			}
		}
	</mat-menu>
}
